import React from 'react'

const SessionTokenForAutofillContext = React.createContext(null)

export const useSessionTokenForAutofill = () => React.useContext(SessionTokenForAutofillContext)

export default SessionTokenForAutofillContext
